import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { MnpEventStatusEnum, MovementNoPurchaseService } from '../../../service/movement-no-purchase.service';
import { UserLoginService } from '../../../service/user-login.service';
import { MnpDetailsPopupData } from '../../popups/movement-no-purchase-details-popup/movement-no-purchase-details-popup.component';

@Component({
  selector: 'app-movement-no-purchase-details',
  templateUrl: './movement-no-purchase-details.component.html',
  styleUrls: ['./movement-no-purchase-details.component.scss'],
  standalone: false,
})
export class MovementNoPurchaseDetailsComponent {
  userService = inject(UserLoginService);
  mnpService = inject(MovementNoPurchaseService);
  router = inject(Router);

  readonly data = input<MnpDetailsPopupData>(undefined);

  isUpdatingStatus = false;

  public get MnpEventStatusEnum() {
    return MnpEventStatusEnum;
  }

  public get statusLabel() {
    switch (this.data().status) {
      case MnpEventStatusEnum.Theft:
        return 'Theft';
      case MnpEventStatusEnum.NotTheft:
        return 'No Theft';
      case MnpEventStatusEnum.OperationalIssue:
        return 'Operational Issue';
      case MnpEventStatusEnum.Unknown:
        return 'Click to review';
    }
  }

  handleStatusChange(newStatus: MnpEventStatusEnum) {
    this.isUpdatingStatus = true;
    this.mnpService.updateStatus(this.data().id, newStatus).subscribe(
      () => {
        this.data().status = newStatus;
      },
      () => {},
      () => {
        this.isUpdatingStatus = false;
      },
    );
  }
}
